const STATUS = {
    ACTIVE: 1,
    INACTIVE: 0
}

export const STATUS_LABEL = {
    [STATUS.ACTIVE]: {
        label: 'Active',
        color: 'green',
        status: STATUS.ACTIVE
    },
    [STATUS.INACTIVE]: {
        label: 'Inactive',
        color: 'default',
        status: STATUS.INACTIVE
    }
}